import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LicensesComponent } from './licenses.component';
import { CardModule } from '../card/card.module'; // Import CardModule
import { LicensesService } from '../../services/licenses.service';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { SpinnerModule, SnackbarMessageModule } from '@ngx-interact-ui/core';

@NgModule({
  declarations: [
    LicensesComponent,
  ],
  imports: [
    CommonModule,
    CardModule,
    HttpClientModule,
    TranslateModule,
    SpinnerModule,
    SnackbarMessageModule
  ],
  exports: [
    LicensesComponent
  ],
   providers: [LicensesService],
   schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LicensesModule {}